export const SOURCE_IMPORT = [
  { name: "onboarding.aliexpress", value: "aliexpress" },
  { name: "onboarding.amazon", value: "amazon" },
  { name: "onboarding.csv", value: "csv" },
];

export const MARKETPLACE = [
  { name: "onboarding.shopify", value: "shopify" },
  { name: "onboarding.ebay", value: "ebay" },
  { name: "onboarding.bigcommerce", value: "bigcommerce" },
];